import React from "react";
import { studies } from "../data/data";

const Studies = () => {
  return (
    <div className="py-32">
      <div className="container mx-auto px-5">
        <div>
          <h3 className="text-6xl font-bold pb-5">Case Studies</h3>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-2 gap-14 pt-16">
          {studies.map((item, index) => (
            <div
              className="p-6 rounded-lg border-b-primary border-2 shadow-2xl"
              key={index}
            >
              <div>
                <img src={item.img} className="h-20" alt="img" />
              </div>
              <h3 className="text-lg text-gray-600 leading-tight mt-5">
                {item.details}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Studies;
